import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';

type Variables = {
  organizationId: string;
  roleAssignmentId: string;
};

export const useRemoveOrganizationMember = () => {
  const api = useGrapevineOrganizationApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, roleAssignmentId }: Variables) =>
      api.removeOrganizationMember({ organizationId, roleAssignmentId }),
    onSuccess: (_data, { organizationId }) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATION_MEMBERS, organizationId]
      });
      // The removed person (incl. the current user when leaving) loses this org
      // from their own-organization list.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_ORGANIZATIONS]
      });
      // Membership changes can affect available creation senders.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
      // The organization detail embeds its members.
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATION, organizationId]
      });
    }
  });
};
